import { createAxiosPlugin } from '../../shared/axios.js';
/**
 * node/axios
 */
export const nodeAxios = createAxiosPlugin('node');
